module.exports = __webpack_public_path__ + "static/media/treadly-app.439949a7.png";